/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { APIMeta } from './APIMeta';
import {
    APIMetaFromJSON,
    APIMetaFromJSONTyped,
    APIMetaToJSON,
} from './APIMeta';
import type { APIResponseError } from './APIResponseError';
import {
    APIResponseErrorFromJSON,
    APIResponseErrorFromJSONTyped,
    APIResponseErrorToJSON,
} from './APIResponseError';
import type { ValidateTokenResponse } from './ValidateTokenResponse';
import {
    ValidateTokenResponseFromJSON,
    ValidateTokenResponseFromJSONTyped,
    ValidateTokenResponseToJSON,
} from './ValidateTokenResponse';

/**
 * 
 * @export
 * @interface PostTokenValidate200Response
 */
export interface PostTokenValidate200Response {
    /**
     * 
     * @type {APIMeta}
     * @memberof PostTokenValidate200Response
     */
    meta?: APIMeta;
    /**
     * 
     * @type {Array<APIResponseError>}
     * @memberof PostTokenValidate200Response
     */
    errors?: Array<APIResponseError>;
    /**
     * 
     * @type {ValidateTokenResponse}
     * @memberof PostTokenValidate200Response
     */
    result?: ValidateTokenResponse;
}

/**
 * Check if a given object implements the PostTokenValidate200Response interface.
 */
export function instanceOfPostTokenValidate200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PostTokenValidate200ResponseFromJSON(json: any): PostTokenValidate200Response {
    return PostTokenValidate200ResponseFromJSONTyped(json, false);
}

export function PostTokenValidate200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostTokenValidate200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'meta': !exists(json, 'meta') ? undefined : APIMetaFromJSON(json['meta']),
        'errors': !exists(json, 'errors') ? undefined : ((json['errors'] as Array<any>).map(APIResponseErrorFromJSON)),
        'result': !exists(json, 'result') ? undefined : ValidateTokenResponseFromJSON(json['result']),
    };
}

export function PostTokenValidate200ResponseToJSON(value?: PostTokenValidate200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'meta': APIMetaToJSON(value.meta),
        'errors': value.errors === undefined ? undefined : ((value.errors as Array<any>).map(APIResponseErrorToJSON)),
        'result': ValidateTokenResponseToJSON(value.result),
    };
}

